import styled from "styled-components"

export const Wrapper = styled.div`
  position: fixed;
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  height: calc(100vh - 84px); // <-- вместо хука
  top: 84px; // <-- позиционирование под шапкой
  left: 0;
  display: flex;
  flex-direction: column;
  padding: 3rem 2rem 5rem 2rem;

  @media (max-width: 650px) {
    padding: 3rem 1rem 10rem 1rem;
    height: calc(100vh - 64px);
    top: 64px;
  }
`

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
  width: 100%;
  min-width: 768px;
  max-width: ${({ $maxWidth }) => $maxWidth || 610}px;
`

export const ActionsWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  max-width: 600px;
  align-items: center;
`

export const SectionWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  column-gap: 10px;
  row-gap: 25px;
  max-width: ${({ $maxWidth }) => $maxWidth}px;
  @media (max-width: 649px) {  
    row-gap: 30px;
  }
`

export const RowWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 765px;
  flex-wrap: nowrap;
  gap: 10px;
`

export const CommentWrapper = styled.div`
  width: 100%;
  @media (max-width: 649px) { 
    margin-bottom: 30px;
  }
`

export const Table = styled.table`
  overflow-y: auto;
  overflow-x: auto;
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  color: var(--text-color);
  margin-right: 1rem;
`

export const Thead = styled.thead`
  background-color: transparent;
`

export const Tbody = styled.tbody`
  & tr:last-child {
    border-bottom: none;
  }
`

export const Tr = styled.tr``

export const Th = styled.th`
  padding: 8px;
  text-align: left;
  border: 1px solid var(--grey-color);
  text-align: center;
  vertical-align: middle;
`

export const Td = styled.td`
  padding: ${({ $padding = '8px' }) => $padding};
  border: 1px solid var(--grey-color);
  text-align: center;
  vertical-align: middle;
`


